/**
 * Gestion des messages FR des pages
 */

module.exports = {

    auth: {
        login: {
            title: 'Log in'
        },
        register: {
            title: 'Sign in'
        },
        forgotPassword: {
            title: 'Password forgotten'
        },
        resetPassword: {
            title: 'Reset password'
        },
        initPassword: {
            title: 'Reset your password'
        }
    },

    privacyPolicy: {
        title: 'Privacy policy',
        browserNotCompatible: 'Your browser cannot display the file.',
        buttons: {
            downloadPdf: {
                label: 'Download the file',
                altLabel: 'Download the Privacy Policy PDF file.'
            }
        }
    },

    home: {
        title: 'Hello { user }',
        description: 'Welcome to your dashboard',
        createPublication: {
            button: {
                label: 'Add a oublication'
            }
        },
        return: {
            planned: 'The task { task } has been scheduled to process your return.',
            validated: 'The task { task } has been validated.',
            publicationWaiting: 'The task { task } has been scheduled for publication.',
            completed: 'You have successfully completed the task { task }.',
            published: 'The task { task } has been published.'
        }
    },

    me: {
        account: {
            title: 'My account',
            description: 'View and modify my account information.',
            statistics: {
                title: 'Statistics',
                description: 'View your statistics.',
                empty: 'No account was found.',
                period: 'From { dateStart } to { dateEnd }',
                account: {
                    empty: 'No data for this period.',
                    statistics: {
                        followers: {
                            facebook: 'fan of the page | fan of the page | fans of the page',
                            instagram: 'follower | follower | followers',
                            linkedin:  'follower | follower | followers',
                            twitter: 'follower | follower | followers',
                        }
                    }
                },
                publications: {
                    empty: 'No data for this period.',
                    panels: {
                        best: {
                            title: 'Top posts'
                        },
                        thematics: {
                            title: 'Thematics',
                            sections: {
                                best: 'Top performing thematics',
                                worst: 'Worst performing thematics'
                            }
                        },
                        schedule: {
                            title: 'Details by time slot'
                        },
                        graphicalLineTemplates: {
                            title: 'Graphic models',
                            empty: 'No data available.'
                        },
                        tones: {
                            title: 'Best performing tones',
                            empty: 'No data available.'
                        },
                        analysis: {
                            title: 'Analysis of publications',
                            sections: {
                                numericalAnalysis: {
                                    title: 'Numerical analysis'
                                },
                                semanticAnalysis: {
                                    title: 'Semantic analysis'
                                },
                                writingModel: {
                                    title: 'Writing model'
                                }
                            },
                            positivePoints: 'Positive points',
                            negativePoints: 'Negative points'
                        },
                        recommendations: {
                            title: 'Recommendations',
                            sections: {
                                thematics: {
                                    title: 'Thematics',
                                    replacement: 'Replace thematic "{ oldThematic }" with thematic "{ newThematic }".'
                                },
                                editorialStyle: {
                                    title: 'Editorial style'
                                },
                                hours: {
                                    title: 'Schedule'
                                }
                            }
                        }
                    },
                    statistics: {
                        actions: 'Number of interactions: { value }',
                        views: 'Number of views: { value }',
                        uniqueViews: '0 unique view | 1 unique view | { value } unique views',
                        engagement: 'Engagement: { value }'
                    },
                    sort: {
                        label: 'Sorting',
                        actions: 'Number of interactions',
                        views: 'Number of views',
                        engagement: 'Engagement rate'
                    },
                    list: {
                        task: {
                            consult: 'View the publication'
                        }
                    }
                }
            },
            bills: {
                list: {
                    title: 'My bills',
                    empty: 'No bill was found.',
                    table: {
                        fields: {
                            date: 'Date',
                            name: 'Bill number',
                            amount: 'Amount',
                            file: 'File',
                            status: 'Status'
                        },
                        file: {
                            download: {
                                altLabel: 'Download the bill { name }.'
                            }
                        },
                        status: {
                            payed: 'Paid bill',
                            toPay: 'Bill to be paid'
                        }
                    }
                }
            },
            socialNetworks: {
                button: {
                    unlink: {
                        network: {
                            altLabel: 'Unlink the { network } network from your account.',
                            confirmation: {
                                message: 'Are you sure you want to unlink { network } from your account? If you have scheduled posts, they will not be able to be published to this network.',
                                error: 'An error occurred while unlinking the account.'
                            }
                        },
                        informations: {
                            label: 'How to unlink { applicationName } from these social media ?'
                        }
                    }
                }
            },
            aiPostImageList: {
                empty: 'No images found.',
                title: 'Images',
                addImagesButton: {
                    label: 'Add images'
                }
            },
            cancelTrialPeriod: {
                button: {
                    label: 'Cancel the trial period'
                },
                confirmationModal: {
                    message: 'Are you sure you want to cancel your trial period? By canceling your trial period, you will continue to have access to its features until { date }. After that, you will need to purchase a subscription.',
                    error: 'An error occurred while cancelling your trial period.'
                }
            },
            removeAccount: {
                button: {
                    label: 'Delete account',
                    altLabel: 'Start the process to delete your account.'
                },
                confirmationModal: {
                    message: 'We are sorry to hear that you are leaving us already. Service quality is a priority for us, can we help you with using the solution? An advisor can get in touch with you.',
                    contact: {
                        informations: {
                            title: 'Confirmation of your informations',
                            about: 'Please confirm the following informations so that we can contact you.',
                            success: 'Your request has been sent successfully.',

                            form: {
                                error: 'An error occurred while sending your request.',
                                fields: {
                                    firstName: 'First name',
                                    lastName: 'Last name',
                                    email: 'Email address',
                                    phone: 'Phone',
                                    societyName: 'Company'
                                }
                            }
                        },
                    },
                    remove: {
                        message: 'All data will be deleted. You will no longer have access to your schedules, and access permissions to your social networks will be revoked.',
                        error: 'An error occurred while deleting your account.',
                        buttons: {
                            confirm: {
                                label: 'I confirm the deletion'
                            }
                        }
                    },
                    buttons: {
                        contact: {
                            label: 'Yes, contact me',
                            altLabel: 'Request to be contacted by an advisor.'
                        },
                        remove: {
                            label: 'Delete my account',
                            altLabel: 'Confirm account deletion.'
                        }
                    }
                }
            },
            writingStyles: {
                title: 'Writing style',
            },
            identityVisual: {
                title: 'Visual identity',
            },
            postsSettings: {
                title: 'Customizing posts'
            },
            repositoryFiles: {
                title: 'My files',
                description: 'Manage the files used to generate your posts.',
                empty: 'No files found',
                add: {
                    button: {
                        label: 'Add a file'
                    }
                },
                edit: {
                    button: {
                        altLabel: 'Edit file { name }.'
                    }
                },
                remove: {
                    button: {
                        altLabel: 'Delete file { name }.'
                    },
                    confirmationModal: {
                        message: 'Are you sure you want to delete the file { name }?',
                        error: 'An error occurred while deleting the file.'
                    }
                },
                table: {
                    fields: {
                        name: 'File name',
                        date: 'Date added',
                        size: 'Size',
                        status: 'Status',
                        actions: 'Actions'
                    },
                    status: {
                        waiting: 'Pending',
                        inProgress: 'Processing',
                        failed: 'Failed',
                        ready: 'Ready'
                    }
                }
            }
        },

        requestedHolidays: {
            requestButton: {
                label: 'Make a request'
            },
            internal: {
                title: 'Holiday requests',
                description: 'View your holiday requests.'
            },
            external: {
                title: 'Absence requests',
                description: 'View your absence requests'
            },
            list: {
                empty: 'No request was found',
                fields: {
                    type: 'Type',
                    period: 'Period',
                    duration: 'Duration',
                    status: 'Status'
                }
            },
            time: '1 day | { count } days',
            delete: {
                modal: {
                    message: 'Are you sure you want to cancel your request for the period from { begin } to { end }?',
                    error: 'An error occurred while deleting your request.'
                }
            }
        },
        ai: {
            planning: {
                subjects: {
                    validation: {
                        title: 'Validate your topics for publications',
                        loadingError: 'An error occurred while loading your topics for publications.'
                    }
                }
            }
        },
        task: {
            // Gestion de tâche par un manager
            managing: {
                list: {
                    title: 'Task completion table',
                    description: 'View your task completion table and task history.',
                    empty: 'No task was found',
                    errorAgents: 'An error occurred while loading the agents.'
                }
            },
            // Tâches d'un agent
            running: {
                list: {
                    title: 'Task completion table',
                    description: 'View your task completion table and task history.',

                    incoming: {
                        loading: {
                            error: 'An error occurred while loading upcoming tasks.'
                        }
                    },

                    processing: {
                        complete: '{ customer } has been notified that the task { task } is waiting for feedback.'
                    }
                }
            },
            write: {
                title: 'Write a publication',
                loadingError: 'An error occurred while loading the task.'
            },
            return: {
                loadingError: 'An error occured while loading a task.',
                title: '{ task } - Return'
            },
            list: {
                customer: {
                    title: 'Posts',
                    description: 'View, create, edit and validate.',
                    empty: 'No task was found.',

                    byMonth: {
                        title: 'Editorial calendar',
                        countCurrentIdeasGeneration: 'posts executed | post executed | posts executed'
                    },

                    subjectsIdeas: {
                        empty: 'The first subjects of your monitoring will appear in a few minutes. Don\'t hesitate to come back regularly.',
                        goToSubscriptionPageButton: {
                            label: 'Subscribe to see more'
                        },
                        addSourceButton: {
                            label: 'Add a monitoring source'
                        }
                    }
                }
            },
            validation: {
                waiting: {
                    title: 'Publications waiting validation',
                    errorLoadTasks: 'An error occurred while loading the publications.',
                    empty: 'You have no publications to check.'
                }
            },
            edit: {
                customer: {
                    title: 'Editing task { task }',
                    loadingError: 'An error occurred while loading the task.',
                    preview: {
                        title: 'Post preview'
                    },
                    taskType: {
                        changeError: 'An error occurred while changing the task type.',
                        type: {
                            image: 'Simple post',
                            carousel: 'Carousel',
                            album: 'Album',
                            video: 'Video'
                        }
                    },
                    taskNetworks: {
                        title: 'Publish on...',
                        addAccountButton: {
                            label: 'Connect a profile'
                        },
                        accountsModal: {
                            label: 'Connect a profile'
                        },
                        tiktokSettings: {
                            title: 'TikTok Video Settings',
                            error: 'An error occurred during saving.',
                            privacy: {
                                label: 'Video Mode',
                                options: {
                                    private: 'Private',
                                    friends: 'Friends only',
                                    public: 'Public'
                                }
                            },
                            comments: {
                                label: 'Can the video receive comments?',
                                options: {
                                    yes: 'Yes',
                                    no: 'No'
                                }
                            },
                            duets: {
                                label: 'Duet Features',
                                options: {
                                    private: 'Only me',
                                    friends: 'Friends only',
                                    public: 'Everyone'
                                },
                                tooltips: {
                                    private: 'Only me : If you select this setting, other users will not be able to create Duets with your videos.',
                                    friends: 'Friends (followers you follow back): If you select this setting and have Duets enabled, only users who follow you and whom you follow back can create Duets with your videos.',
                                    public: 'Everyone: If you select this setting and have Duets enabled, anyone can create Duets with your videos.'
                                }
                            },
                            stitch: {
                                label: 'Stitch Settings',
                                options: {
                                    private: 'Only me',
                                    friends: 'Friends only',
                                    public: 'Everyone'
                                },
                                tooltips: {
                                    private: 'Only me : If you select this setting, other users will not be able to create Stitches with your videos.',
                                    friends: 'Friends (followers you follow back): If you select this setting and have Stitch enabled, only users who follow you and whom you follow back can create Stitches with your videos.',
                                    public: 'Everyone: If you select this setting and have Stitch enabled, anyone can create Stitches with your videos.'
                                }
                            }
                        }
                    },
                    hook: {
                        title: 'Text of the publication',
                        promptPanel: {
                            textarea: {
                                placeholder: 'Instructions for improving your legend... Ask for a shorter or longer legend, in a different tone, addressing a specific audience, integrating bullet points, specifying a subject or integrating a subject'
                            },
                            errors: {
                                prompt: 'An error occurred while processing your request.'
                            }
                        },
                        promptHistorical: {
                            title: 'Prompts History',
                            prompt: {
                                date: 'On { day } at { time }: ',
                                subtitle: 'Instructions given to AI: '
                            }
                        }
                    },
                    media: {
                        title: 'Media',
                        description: {
                            image: 'Edit the visual of your post directly in the graphic editor',
                            video: 'Upload a video'
                        },
                        edit: {
                            button: {
                                label: 'Edit the visual in the graphics editor',
                                labelReduced: 'Edit the visual'
                            }
                        },
                        uploadVideo: {
                            button: {
                                label: 'Upload a video'
                            },
                            specifications: {
                                facebook: {
                                    format: 'Format: 16:9 (landscape), 9:16 (portrait)',
                                    dimensions: 'Recommended dimensions: 1280 x 720 pixels (for 16:9 format), 720 x 1280 pixels (for 9:16 format)',
                                    duration: 'Duration: up to 240 minutes',
                                    types: 'File type: MP4, MOV',
                                    size: 'File size: up to 10 GB maximum'
                                },
                                linkedin: {
                                    format: 'Format: 1:2.4, 2.4:1',
                                    dimensions: 'Recommended dimensions: from 256 x 144 pixels to 4096 x 2304 pixels',
                                    duration: 'Duration: from 3 seconds to 10 minutes',
                                    types: 'File type: MP4, AVI, QuickTime, MOV, ASF, FLV, MPEG-1, MPEG-4, MKV, WebM',
                                    size: 'File size: 5 GB'
                                },
                                instagram: {
                                    formatSquare: 'Square and Carousel - 1080px x 1080px or 1:1 aspect ratio',
                                    formatPortrait: 'Portrait - 1080px x 1350px or aspect ratio 4:5',
                                    formatLandscape: 'Landscape - 1080px x 608px or 16:9 aspect ratio',
                                    duration: '2 min max',
                                    size: '4 GB max'
                                }
                            }
                        },
                        removeVideo: {
                            button: {
                                label: 'Delete the video'
                            }
                        }
                    },
                    footer: {
                        validationButton: {
                            label: 'Schedule the post'
                        },
                        saveButton: {
                            label: 'Save post'
                        },
                        linkAccountsButton: {
                            label: 'Connect your networks to publish'
                        }
                    }
                }
            }
        },

        publicationsComments: {
            list: {
                title: 'Comment management',
                description: 'Manage your publications comments on your social networks.',
                filters: {
                    searching: {
                        placeholder: 'Search a comment by publication title, author, or comment content'
                    },
                    answered: {
                        yes: 'Answered',
                        no: 'Not answered'
                    }
                }
            }
        },

        agency: {
            usersMenuTab: {
                users: 'Users',
                roles: 'Roles'
            },
            users: {
                list: {
                    title: 'Agency user management',
                    table: {
                        fields: {
                            users: 'Users',
                            customers: 'Customers',
                            actions: 'Actions'
                        }
                    }
                },
                removeContact: {
                    button: {
                        altLabel: 'Delete the account of { user }.'
                    },
                    confirmationModal: {
                        error: 'An error occurred while deleting the account.',
                        title: 'Confirm deletion of the account for { user }'
                    }
                },
                createContact: {
                    button: {
                        label: 'Add a user',
                        altLabel: 'Add an account to the agency.'
                    },
                    createModal: {
                        title: 'Add an account to the agency',
                    },
                    createForm: {
                        error: 'An error occurred while creating the account.'
                    }
                },
                editContact: {
                    button: {
                        altLabel: 'Edit the account of { user }.'
                    },
                    editModal: {
                        title: 'Editing the account of { user }',
                    },
                    editForm: {
                        error: 'An error occurred while updating the account of { user }.'
                    },
                },
                manageCustomers: {
                    tabMenu: {
                        current: 'Current customers',
                        add: 'Add a customer',
                    },
                    list: {
                        empty: 'No customers were found.',
                        modal: {
                            title: 'Managing customers for { user }'
                        },
                        fields: {
                            name: 'Name',
                            email: 'Email',
                            society: 'Company'
                        }
                    },
                    remove: {
                        error: 'An error occurred while removing the customer.',
                        modal: {
                            title: 'Remove { customer } from the account of { user }',
                        },
                        button: {
                            altLabel: 'Remove the customer from the account of { user }.'
                        }
                    },
                    add: {
                        error: 'An error occurred while adding the customer.',
                        modal: {
                            title: 'Add { customer } to the account of { user }',
                        },
                        button: {
                            altLabel: 'Add the customer to the account of { user }.'
                        }
                    },
                    button: {
                        consult: {
                            altLabel: 'Manage customers for { user }.'
                        }
                    }
                }
            },
            customers: {
                list: {
                    empty: 'No customers were found.',
                    title: 'List of your customers',
                    fields: {
                        societyName: 'Society name',
                        customerEmail: 'Customer email',
                        withEnabledSubscription: 'Active',
                        agencyRemuneration: 'Agency remuneration',
                        customerPromotion: 'Customer promotion',
                        actions: 'Actions'
                    },
                    globalCounters: {
                        agencyRemuneration: 'Agency remuneration: { amount }',
                        customerPromotion: 'Customer promotion: { amount }',
                        totalSubscriptions: 'Active subscriptions: { count }'
                    },
                    agencyInformation: 'Every month, you receive the cumulative amount from your affiliates in your account. This amount is paid out as soon as you have reached a minimum monthly membership of €50 and upon presentation of an invoice with your organization\'s letterhead sent to { contactEmail }. The invoice must be sent within 90 days.',
                    editTaskButton: {
                        altLabel: 'Edit { customer } tasks.'
                    },
                    consultPublicationsCommentsButton: {
                        altLabel: 'Consult the comments on the publications of { customer }.'
                    },
                    enableAccount: {
                        altLabel: 'Enable the account.'
                    },
                    editAccount: {
                        altLabel: 'Edit { customer } account.'
                    },
                    editSubscription: {
                        altLabel: 'Edit { customer } subscription.'
                    },
                    statistics: {
                        altLabel: 'Consult { customer } statistics.'
                    },
                    graphicalLineTemplates: {
                        altLabel: 'Consult { customer } graphic templates.'
                    },
                    repositoryFiles: {
                        altLabel: 'Consult the files of { customer }.'
                    }
                },
                tasksList: {
                    title: 'Editorial calendar for { customer }',
                },
                postsSettings: {
                    title: 'Customizing posts for { customer }',
                },
                graphicalLineTemplates: {
                    title: 'Graphic models for { customer }',
                },
                editAccount: {
                    description: 'Consult and edit { customer } informations.'
                },
                subscription: {
                    description: 'Subscribe or change { customer } subscription'
                },
                publicationsComments: {
                    title: 'Comments on the publications of { customer }',
                    description: 'Manage the comments on the publications of { customer }.'
                },
                statistics: {
                    title: '{ customer } statistics',
                    description: 'Consult { customer } statistics.'
                },
                writingStyles: {
                    title: '{ customer } writing style',
                },
                visualIdentity: {
                    title: '{ customer } visual identity'
                },
                repositoryFiles: {
                    title: 'Files of { customer }',
                    description: 'Manage the files to be used to generate the publications for { customer }.'
                }
            },
            bills: {
                list: {
                    title: 'Your latest bills'
                }
            },
            affiliationCodes: {
                list: {
                    title: 'Affiliate codes',
                    empty: 'No affiliate code was found.',
                    fields: {
                        code: 'Affiliate code',
                        agencyRemuneration: 'Agency remuneration percentage',
                        customerPromotion: 'Customer promotion percentage',
                        actions: 'Actions'
                    }
                },
                button: {
                    add: {
                        label: 'Add a code'
                    },
                    edit: {
                        altLabel: 'Editing the affiliate code { code }.'
                    }
                }
            },

        }
    },

    admin: {
        // Page de paramètres pour le Super Admin
        superAdmin: {
            settings: {
                title: 'Parameters for Super Admin',
                description: 'Edit an application as a Super Admin',
                buttons: {
                    aiTest: {
                        label: 'Test IA',
                        altLabel: 'Test the prompts for the AI.'
                    }
                },
            },
            aiTest: {
                title: 'Prompt testing with AI APIs',
                response: {
                    timing: 'The API responded in { timing } seconds.',
                    choices: {
                        title: 'Answer from OpenAI | Answer from OpenAI | Answer from OpenAI',
                        empty: 'No answer was received by AI API\'s.',
                        item: {
                            title: 'Choice { position }'
                        }
                    },
                    usage: '{ total } tokens were used ({ promptTokens } for the prompt, { completionTokens } for the answer).'
                },
                geminiResponse: {
                    empty: 'The image could not be generated.'
                },
                '123rfResponse': {
                    empty: 'No image was received.'
                },
                blackForestLabsResponse: {
                    empty: 'The image could not be generated.'
                }
            },
            socialNetworks: {
                title: 'Update Super Admin social networks access tokens'
            }
        },

        // Templates des chartes graphiques
        graphicalLineTemplate: {
            list: {
                title: 'Manage your graphic models',
                description: 'Manage the graphic models to be used for publications.',
                empty: 'No graphic model was found.',
                filters: {
                    owner: 'My graphic models',
                    all: 'All graphic models',
                    type: {
                        default: 'Filter type',
                        single: 'Single picture',
                        carousel: 'Carousel'
                    },
                    thematic: {
                        placeholder: 'Thematic to filter'
                    }
                }
            },
            addButton: {
                label: 'Add my model',
                altLabel: 'Add a graphic model.'
            },
            editButton: {
                altLabel: 'Edit a graphic model { name }.'
            },
            removeButton: {
                altLabel: 'Remove the graphic model { name }.'
            }
        },

        // Codes de promotion
        promotionCodes: {
            title: 'Promotion Codes',
            list: {
                empty: 'No promotion code was found.',
                fields: {
                    alphaCode: 'Code'
                }
            },
            item: {
                edit: {
                    button: {
                        altLabel: 'Edit the promotion code { code }.'
                    }
                }
            }
        },

        // Factures
        bills: {
            title: 'Bills',
            list: {
                empty: 'No bill was found.',
                fields: {
                    date: 'Date',
                    name: 'Bill number',
                    customer: {
                        name: 'Customer name',
                        email: 'Customer\'s E-mail',
                        society: {
                            name: 'Society'
                        }
                    },
                    amount: 'Amount',
                    file: 'Bill',
                    status: 'Status'
                },
                file: {
                    download: {
                        altLabel: 'Download a bill { name }.'
                    }
                },
                filters: {
                    date: {
                        start: 'From',
                        end: 'to'
                    }
                }
            },
        },

        // Demande de congés
        requestedHolidays: {
            list: {
                title: 'Holiday requests',
                description: 'View, validate or refuse the holiday requests of your agents.',
                empty: 'There are no requests matching your search.',
                fields: {
                    agent: {
                        code: 'Code',
                        name: 'Agent'
                    },
                    type: 'Type',
                    period: 'Period',
                    duration: 'Duration',
                    remaining: 'Remaining',
                    status: 'Status'
                },
                time: '1 day | { count } days',
            },
            accept: {
                button: {
                    label: 'Accept a request'
                }
            },
            decline: {
                button: {
                    label: 'Refuse the request.'
                },
                modal: {
                    title: 'Refusal of the request.',
                    message: 'Specify the reason for refusing the request for the absence of { name } for the period { start } to { end }.'
                }
            }
        },

        // Administration des crédits
        credits: {
            title: 'Manage your credits and subscriptions',
            list: {
                credits: {
                    loadingError: 'An error occurred while loading credit packs.',
                    tab: {
                        credits: 'Credits',
                        subscription: 'Subscription',
                        statistics: 'Statistics'
                    },
                    fields: {
                        name: 'Name',
                        credits: 'Credits',
                        unitPriceWithoutTax: 'Price before tax'
                    },
                    title: {
                        unique: 'Credit prices',
                        monthly: 'Prices and subscriptions'
                    }
                },
                taskConfigurations: {
                    title: 'Task configuration / Credits',
                    fields: {
                        name: 'Task',
                        credits: 'Credit value',
                        time: 'Time'
                    }
                }
            },
            edit: {
                button: {
                    altLabel: {
                        unique: 'Edit the price { name }.',
                        monthly: 'Edit a subscription { name }.'
                    }
                }
            },
            taskConfiguration: {
                edit: {
                    button: {
                        altLabel: 'Edit the task configuration { name }.'
                    }
                }
            },
            manageVisibility: {
                button: {
                    altLabel: {
                        unique: 'Manage price list user segments { name }.',
                        monthly: 'Manage subscription user segments { name }.'
                    }
                }
            },
            modal: {
                credits: {
                    edit: {
                        title: {
                            unique: 'Edit a credit price',
                            monthly: 'Edit a subscription'
                        }
                    },
                    manageVisibility: {
                        title: 'User segment configurator'
                    }
                },
            }
        },

        taskConfigurations: {
            groups: {
                list: {
                    title: 'Task configuration groups',
                    description: 'Manage task configuration groups to organise the formats of a client\'s task creation form.',
                    empty: 'No group was found.',
                    add: {
                        button: {
                            label: 'Add a group'
                        }
                    },
                    edit: {
                        button: {
                            altLabel: 'Edit a group { name }.'
                        }
                    },
                    editTaskConfigurations: {
                        button: {
                            label: 'Tasks',
                        }
                    }
                }
            }
        },

        videos: {
            tutorial: {
                menu: {
                    categories: 'Categories',
                    questions: 'Questions',
                    videos: 'Videos'
                },
                list: {
                    title: 'Managing tutorial videos',
                    description: 'Managing categories, questions and tutorial videos.'
                },
                category: {
                    list: {
                        error: 'An error occurred while loading the categories list.',
                        empty: 'There is no category.'
                    },
                    addButton: {
                        label: 'Add a category'
                    },
                    editButton: {
                        altLabel: 'Edit the { category } category.'
                    }
                },
                question: {
                    list: {
                        error: 'An error occurred while loading the questions list.',
                        empty: 'There is no question.'
                    },
                    addButton: {
                        label: 'Add a question'
                    },
                    editButton: {
                        altLabel: 'Edit the { question } question.'
                    }
                },
                video: {
                    list: {
                        error: 'An error occurred while loading the videos list.',
                        empty: 'There is no video.'
                    },
                    addButton: {
                        label: 'Add a video'
                    },
                    editButton: {
                        altLabel: 'Edit the { video } video.'
                    }
                }
            },
            list: {
                title: 'Manage your videos',
                description: 'Manage the videos offered to customers when they create a publication.',
                empty: 'No video was found.',
                loadTaskConfigurations: {
                    error: 'An error occurred whule loading formats.'
                },
                add: {
                    button: {
                        label: 'Add a video'
                    }
                },
                edit: {
                    button: {
                        altLabel: 'Modify a video { video }.'
                    }
                }
            },
            import: {
                button: {
                    label: 'Import videos'
                }
            }
        },

        publicationIdeas: {
            list: {
                title: 'Manage your publication ideas',
                description: 'Manage the publication ideas proposed to customers when they create a publication.',
                empty: 'No idea for publication was found.',
                loadTaskConfigurations: {
                    error: 'An error occurred while loading the formats.'
                },
                add: {
                    button: {
                        label: 'Add an idea for publication'
                    }
                },
                edit: {
                    button: {
                        altLabel: 'Modify an idea { idea }.'
                    }
                }
            },
            import: {
                button: {
                    label: 'Import the ideas for publication'
                }
            }
        },

        // Gestion du marronnier
        horseChestnut: {
            loadEvent: {
                error: 'An error occurred while loading the event.'
            },
            list: {
                title: 'Evergreen configuration',
                description: 'View and edit your evergreens.',
                empty: 'No event was found.',
                loadResources: {
                    error: 'An error was occurred while loading the data.'
                },
            }
        },

        // Gestion des permissions
        permissions: {
            sections: {
                list: {
                    title: 'List of permission sections',
                    description: 'Manage the organisation of permissions',
                    warning: 'Be very careful when making changes or additions to permissions. This has an impact on roles.',
                    empty: 'No permissions section matches your search.',
                    fields: {
                        name: 'Name'
                    },
                    create: {
                        button: {
                            label: 'Add a section',
                            altLabel: 'Configure a new section'
                        }
                    },
                    edit: {
                        button: {
                            altLabel: 'Edit a section { name }.'
                        }
                    }
                },
                edit: {
                    title: 'Edit permission section { name }',
                    description: 'Manage the permission groups in this section.',
                    loadingError: 'An error occurred while loading a data.',
                    groups: {
                        title: 'List of groups in the section { name }',
                        empty: 'There is no group in this section.',
                        fields: {
                            name: 'Name',
                            type: 'Type'
                        },
                        type: {
                            crud: 'CRUD',
                            authorization: 'Autorization'
                        },
                        edit: {
                            button: {
                                altLabel: 'Edit a group { name }.'
                            }
                        },
                        create: {
                            button: {
                                label: 'Add a group',
                                altLabel: 'Add a group in the section { name }.'
                            }
                        },
                        permissions: {
                            fields: {
                                name: 'Name',
                                type: 'Type'
                            },
                            type: {
                                consult: 'Consult',
                                create: 'Create',
                                edit: 'Edit',
                                delete: 'Delete',
                                authorized: 'Autorization',
                                grant: 'Grant'
                            },
                            edit: {
                                button: {
                                    altLabel: 'Edit a permission { name }.'
                                }
                            },
                            add: {
                                button: {
                                    label: 'Add a permission',
                                    altLabel: 'Add a permission in the group { name }.'
                                }
                            }
                        }
                    }
                }
            }
        },
        // Gestion des rôles
        roles: {
            list: {
                title: 'List of roles',
                description: 'Define the roles to be assigned to your users.',
                empty: 'There is no role matching your search.',
                fields: {
                    name: 'Name',
                    owner: 'Owner',
                    countUsers: 'Users'
                },
                create: {
                    button: {
                        label: 'Add a role',
                        altLabel: 'Configure a new role.'
                    }
                },
                edit: {
                    button: {
                        altLabel: 'Edit a role { name }.'
                    }
                }
            },
            create: {
                title: 'Create a role',
                description: 'Define the permissions of a new role.',
                loadingError: 'An error occurred while loading permissions.'
            },
            edit: {
                title: 'Edit a role { name }',
                description: 'Define the list of permissions for users with the role { name }.',
                loadingError: 'An error occurred while loading a role.',
                permissions: {
                    allowed: 'Allowed',
                    grant: 'Grant',
                    consult: 'Consult',
                    create: 'Create',
                    edit: 'Edit',
                    delete: 'Delete'
                }
            }
        },

        // Personnalisation de l'application
        customizeApplication: {
            title: 'Customize application',
            description: 'Manage your application\'s T&Cs and privacy policy.',
            loadingError: 'An error occured while loading an application.',
            manageGraphicalLineTemplatesButton: {
                label: 'Graphic charts',
                altLabel: 'Manage your graphic charts'
            }
        },

        // Gestion des mails internes
        mails: {
            title: 'Internal e-mail configuration',
            description: 'View or modify email content',
            list: {
                empty: 'There is no e-mail matching your search.',
                fields: {
                    name: 'Name',
                    lang: 'Language'
                },
                item: {
                    edit: {
                        altLabel: 'Modify an e-mail { name }.'
                    }
                },
                searching: {
                    placeholder: 'Initialize, Task, Validate...'
                }
            }
        },

        // Gestion des contacts
        contacts: {
            title: 'Manage your contacts',
            description: 'Manage the list of users attached to your account.',
            list: {
                empty: 'There is no contact matching your search.',
                fields: {
                    name: 'Name',
                    email: 'E-mail adress',
                    createdAt: 'Created at'
                },
                create: {
                    button: {
                        label: 'Add a contact',
                        altLabel: 'Add a contact to your accont.'
                    }
                },
                item: {
                    impersonate: {
                        altLabel: 'Log in as { user }.'
                    },
                    invite: {
                        altLabel: 'Invite { name } to connect.'
                    },
                    edit: {
                        altLabel: 'Modify an account { name }.'
                    },
                    remove: {
                        altLabel: 'Delete an account { name }.'
                    }
                }
            }
        },

        // Gestion des secteurs d'activités
        activitySectors: {
            title: 'List of activity sectors',
            description: 'Manage the list of business sectors and their professions.',
            list: {
                empty: 'There is no activity sector matching your search.',
                fields: {
                    name: 'Name',
                    parent: 'Parent sector'
                },
                searching: {
                    placeholder: 'Florist, Baker, IT...'
                },
                edit: {
                    button: {
                        altLabel: 'Edit an activity sector { name }.'
                    }
                },
                create: {
                    button: {
                        label: 'Add a sector',
                        altLabel: 'Add a new sector'
                    }
                },
                item: {
                    edit: {
                        altLabel: 'Modidy a sector { name }.'
                    }
                }
            },
            create: {
                title: 'Add an activity secteur',
                description: 'Setting up an new activity sector.'
            },
            edit: {
                title: 'Edit the activity sector { name }',
                description: 'Modify the activity sector { name } and manage its professions.',
                loadingError: 'An error occurred while loading an activity sector.'
            }
        },

        // Message de désinscription
        unsubscribeMessages: {
            list: {
                title: 'Unsubscribe messages',
                description: 'Manage unsubscribe messages and view statistics.',
                empty: 'No unsubscribe message was found.',
                fields: {
                    message: 'Message',
                    enabled: 'Enabled',
                    countUsed: 'Answers'
                },
                enabledStatus: {
                    enabled: 'Yes',
                    disabled: 'No'
                },
                create: {
                    button: {
                        label: 'Add a message',
                        altLabel: 'Configure a new unsubscribe message.'
                    }
                },
                edit: {
                    button: {
                        altLabel: 'Edit an unsubscribe message { message }.'
                    }
                }

            },
            statistics: {
                table: {
                    fields: {
                        reason: 'Reason',
                        countUsed: 'Vote number'
                    }
                }
            }
        },

        // Gestion des utilisateurs
        users: {
            edit: {
                loading: 'An error occurred while loading an identifier.',
                created: 'An account { name } was successfully created.',
                updated: 'An account { name } was successfully updated.',
                tabs: {
                    informations: 'Informations',
                    planning: 'Planning'
                }
            },
            agentStatus: {
                enable: {
                    altLabel: 'Click here to enable an agent.'
                },
                disable: {
                    altLabel: 'Click here to disable an agent.'
                }
            },
            list: {
                fields: {
                    name: 'Nom',
                    email: 'E-mail',
                    phone: 'Phone',
                    code: 'Code',
                    createdAt: 'Created at',
                    customerAgent: 'Associated agent',
                    society: 'Society',
                    activitySector: 'Sector',
                    credits: 'Credits',
                    contract: {
                        start: 'Entry date',
                        type: 'Contract'
                    },
                    networksAccounts: 'Social networks',
                    counters: {
                        agents: {
                            label: 'Agents',
                            altLabel: 'Number of managed agents'
                        },
                        features: {
                            label: 'Features',
                            altLabel: 'Number of features'
                        }
                    }
                },
                loading: {
                    activitySectors: {
                        error: 'An error occurred while loading the activity sectors.'
                    }
                },
                item: {
                    editButton: {
                        altLabel: 'Edit the information of { name }.'
                    }
                }
            },
            internalAgent: {
                create: {
                    title: 'Add an internal agent.',
                    description: 'Create an internal agent for the company'
                },
                edit: {
                    title: 'Edit an internal agent { name }',
                    description: 'Edit an internal agent { name }.'
                },
                list: {
                    title: 'List of internal agents',
                    description: 'Manage the list of internal agents',
                    createUserButton: {
                        label: 'Add an agent',
                        altLabel: 'Add a new internal agent.'
                    },
                    empty: 'There is no internal agent matching your search.',

                }
            },
            externalAgent: {
                create: {
                    title: 'Add an external agent',
                    description: 'Create an external agent for the company.'
                },
                edit: {
                    title: 'Edit an external agent { name }',
                    description: 'Edit an external agent { name }.'
                },
                list: {
                    title: 'List of external agents',
                    description: 'Manage the list of external agents.',
                    createUserButton: {
                        label: 'Add an agent',
                        altLabel: 'Add a new external agent.'
                    },
                    empty: 'There in no external agent matching your search.'
                }
            },
            teamManager: {
                create: {
                    title: 'Add a manager',
                    description: 'Create a team leader who can manage his team.'
                },
                edit: {
                    title: 'Edit a manager { name }',
                    description: 'Edit a manager { name }.',
                    agents: 'List of agents managed by { name }'
                },
                list: {
                    title: 'List of managers',
                    description: 'Manage the list of team leaders.',
                    createUserButton: {
                        label: 'Add a manager',
                        altLabel: 'Add a new manager'
                    },
                    empty: 'There is no manager matching your search.'
                }
            },
            productManager: {
                create: {
                    title: 'Add a product manager',
                    description: 'Create a product manager who can manage notifications and customer appointments.'
                },
                edit: {
                    title: 'Edit a product manager { name }',
                    description: 'Edit a product manager { name }.'
                },
                list: {
                    title: 'List of product managers',
                    description: 'Manage the list of product managers.',
                    createUserButton: {
                        label: 'Add a product manager',
                        altLabel: 'Add a new product manager.'
                    },
                    empty: 'There are no product managers matching your search criteria.'
                },
            },
            agencyManager: {
                list: {
                    title: 'List of agency managers',
                    description: 'Manage the list of agency managers.',
                    empty: 'No agency manager matches your search.'
                },
                button: {
                    displayCustomers: {
                        altLabel: 'View customers of the agency { agency }.'
                    }
                }
            },
            customer: {
                create: {
                    title: 'Add a customer',
                    description: 'Create a new customer'
                },
                edit: {
                    title: 'Edit a customer { name }',
                    description: 'Edit a customer { name }.'
                },
                list: {
                    title: 'List of customers',
                    description: 'Manage the list of customers.',
                    createUserButton: {
                        label: 'Add a customer',
                        altLabel: 'Add a new customer'
                    },
                    exportButton: {
                        label: 'Export customers',
                        altLabel: 'Export customer list to CSV format'
                    },
                    empty: 'There is no customer matching your search criteria.',
                    searching: {
                        name: {
                            placeholder: 'Jean-Charles, Annick, Elisabeth...'
                        },
                        email: {
                            placeholder: 'Search by E-mail  adress'
                        },
                        society: {
                            placeholder: 'Search by the society\'s name'
                        }
                    }
                }
            }
        },

        // Gestion des offres de coaching
        coachingOffers: {
            list: {
                title: 'List of coaching offers',
                description: 'Manage the coaching offers',
                create: {
                    button: {
                        label: 'Add an offer',
                        altLabel: 'Configure a new coaching offer.'
                    }
                },
                empty: 'There is no coaching offer matching your search.',
                fields: {
                    name: 'Name',
                    time: 'Time',
                    credits: 'Credits'
                },
                item: {
                    edit: {
                        altLabel: 'Edit an offer { name }.'
                    },
                    delete: {
                        altLabel: 'Delete an offer { name }.'
                    }
                }
            },
            create: {
                title: 'Add a coaching offer',
                description: 'Set up a new coaching offer.'
            },
            edit: {
                title: 'Edit a coaching offer { name }',
                description: 'Edit the offer settings',
                loadingError: 'An error occurred while loading the offer.',
                created: 'The offer { name } was successfully created.',
                updated: 'The offer { name } was successfully updated.',
            },
            remove: {
                title: 'Deletion of the coaching offer { name }',
                error: 'An error occurred while deleting the offer.'
            }
        }


    },

    // Résumé des factures des clients d'une agence
    digestBills: {
        list: {
            empty: 'No invoices were found.',
            fields: {
                date: 'Date',
                name: 'Invoice number',
                amount: 'Amount',
                file: 'Invoice'
            },
            file: {
                download: {
                    altLabel: 'Download invoice { name }.'
                }
            }
        }
    }

};
